import { useEffect, useState } from 'react';
import { Box, Button, Checkbox, Typography } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';
import { Panel } from '../../components/Panel';

const KEY = 'runner_kit_checklist_v1';

/** First-30-days checklist (spec §16 tool #4). Ticks live in localStorage only. */
export function Checklist() {
  const { t } = useTranslation();
  const items = t('checklist.items', { returnObjects: true }) as string[];
  const [done, setDone] = useState<boolean[]>(() => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as boolean[];
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(done));
    } catch {
      /* no storage */
    }
  }, [done]);
  const count = done.filter(Boolean).length;
  return (
    <Panel title={`${t('checklist.title')} · ${count}/${items.length}`} accent="#2E9E3A">
      <Typography sx={{ color: '#4b5563', fontSize: '14px', mb: 1.5 }}>{t('checklist.intro')}</Typography>
      {items.map((label, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5, borderBottom: '1px solid #f1f5f9' }}>
          <Checkbox ariaLabel={label} checked={Boolean(done[i])} onChange={() => setDone((d) => { const n = [...d]; n[i] = !n[i]; return n; })} />
          <Typography sx={{ fontSize: '14px', color: done[i] ? '#5f6b7a' : '#1f2937', textDecoration: done[i] ? 'line-through' : 'none' }}>{i + 1}. {label}</Typography>
        </Box>
      ))}
      <Button ariaLabel={t('checklist.reset')} buttonText={t('checklist.reset')} variant="text" size="small" sx={{ mt: 1, color: '#5f6b7a' }} onClick={() => setDone([])} />
    </Panel>
  );
}
